module.exports = __webpack_public_path__ + "static/media/gq.1f78740d.svg";